import { CommunicationResource } from "../locales";

export const communication: CommunicationResource = {
    digitalMaterial: "Matériel digital",
    tastings: "Dégustations",
    storeMaterial: "Matériel de magasin",
    campaignMaterial: "Matériel de campagne",
    news: "Nouveautés",
};
